// extracted by mini-css-extract-plugin
export default {"uppercase":"acbypC","heading":"ZUZgss","details":"HYCbe0","dataRow":"r_9dc3","actions":"PyjExs","cancelButton":"axbc7w","deleteButton":"rm1_S5","confirmDeleteText":"XdNt5H"};